import React, {useEffect, useState} from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Calendar from '../../../shared/components/Calendar'
import events from '../../DefaultPages/Calendar/components/events';
import Spinner from 'react-bootstrap/Spinner';

const ProfileCalendar = () => {
  const user = JSON.parse(sessionStorage.getItem('usuario'));
  const [dataEvents, setDataEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const fecha = new Date();

  const getCalendarData = async () => {

    setLoading(true);

    await fetch(process.env.REACT_APP_PUBLIC_URL + 'calendario/listar?id_usuario=' + user.id_usuario + '&month=' + (fecha.getMonth() + 1) + '&year=' + fecha.getFullYear(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + sessionStorage.getItem('token'),
      }
    })
      .then(response => {
        return response.json();
      })
      .then(data => {
        //console.log(data);               
        filterData(data);

      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const filterData = (data) => {
    let newData = [];

    for (let i = 0; i < data.length; i++) {
      newData[i] = {
        id: data[i].id_calendario,
        title: data[i].titulo,
        start: new Date(data[i].fecha_inicio),
        end: new Date(data[i].fecha_final),
        priority: data[i].prioridad === 1 ? 'non' : data[i].prioridad === 2 ? 'family' : 'high',
      }
    }

    setDataEvents(newData);
    setLoading(false);
    console.log(newData);
  }

  useEffect(() => {
    getCalendarData();
  }, []);

  return (
    <Col md={12} lg={12} xl={12}>
      <Card>
        <CardBody className="profile__card--calendar">
          {loading ?
            <Spinner animation="border" variant="success" />
            :
            <Calendar events={dataEvents} small />
          }
        </CardBody>
      </Card>
    </Col>
  );
}

export default ProfileCalendar;
